var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-card", staticStyle: { width: "500px" } },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        !_vm.isNew
          ? _c("p", { staticClass: "modal-card-title has-text-weight-bold" }, [
              _vm._v(" " + _vm._s(_vm.$t("button.edit")) + " ")
            ])
          : _vm._e(),
        _vm.isNew
          ? _c("p", { staticClass: "modal-card-title has-text-weight-bold" }, [
              _vm._v(" " + _vm._s(_vm.$t("button.add")) + " ")
            ])
          : _vm._e()
      ]),
      _c(
        "section",
        {
          staticClass: "modal-card-body",
          staticStyle: { overflow: "visible" }
        },
        [
          _c(
            "b-field",
            { attrs: { horizontal: "", label: _vm.$t("label.height") } },
            [
              _c(
                "b-select",
                {
                  attrs: { expanded: "" },
                  model: {
                    value: _vm.form.height,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "height", $$v)
                    },
                    expression: "form.height"
                  }
                },
                [
                  _c("option", { attrs: { value: "1/2" } }, [_vm._v("1/2")]),
                  _c("option", { attrs: { value: "full" } }, [
                    _vm._v(_vm._s(_vm.$t("label.full")))
                  ])
                ]
              )
            ],
            1
          ),
          _c(
            "b-field",
            { attrs: { horizontal: "", label: _vm.$t("label.width") } },
            [
              _c(
                "b-select",
                {
                  attrs: { expanded: "" },
                  model: {
                    value: _vm.form.width,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "width", $$v)
                    },
                    expression: "form.width"
                  }
                },
                [
                  _c("option", { attrs: { value: "1/2" } }, [_vm._v("1/2")]),
                  _c("option", { attrs: { value: "full" } }, [
                    _vm._v(_vm._s(_vm.$t("label.full")))
                  ])
                ]
              )
            ],
            1
          ),
          _c(
            "b-field",
            { attrs: { horizontal: "", label: _vm.$t("label.order") } },
            [
              _c("b-input", {
                attrs: {
                  placeholder: _vm.$t("placeholder.input_order"),
                  expanded: "",
                  type: "number"
                },
                model: {
                  value: _vm.form.order,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "order", $$v)
                  },
                  expression: "form.order"
                }
              })
            ],
            1
          ),
          _c(
            "b-field",
            { attrs: { horizontal: "", label: _vm.$t("label.feature") } },
            [
              _c(
                "b-select",
                {
                  attrs: { expanded: "" },
                  on: { input: _vm.onSelectFeature },
                  model: {
                    value: _vm.form.feature,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "feature", $$v)
                    },
                    expression: "form.feature"
                  }
                },
                _vm._l(_vm.featuresSelect, function(featureVal, featureName) {
                  return _c(
                    "option",
                    { key: featureName, domProps: { value: featureVal } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("widget_setting." + featureVal)) +
                          " "
                      )
                    ]
                  )
                }),
                0
              )
            ],
            1
          ),
          _c("b-field", { attrs: { horizontal: "", label: "Options" } }, [
            _c(
              "div",
              { staticClass: "box p-3" },
              _vm._l(_vm.featureOptions[_vm.form.feature], function(
                option,
                optionName
              ) {
                return _c(
                  "b-field",
                  {
                    key: _vm.form.feature + optionName,
                    staticClass: "mb-4",
                    attrs: { label: _vm.$t("label." + optionName) }
                  },
                  [
                    option.type === "select"
                      ? [
                          _c(
                            "b-select",
                            {
                              attrs: { expanded: "" },
                              model: {
                                value: _vm.form.options[optionName],
                                callback: function($$v) {
                                  _vm.$set(_vm.form.options, optionName, $$v)
                                },
                                expression: "form.options[optionName]"
                              }
                            },
                            _vm._l(option.options, function(item) {
                              return _c(
                                "option",
                                { key: item, domProps: { value: item } },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("label." + item)) + " "
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      : option.type === "select-filter"
                      ? [
                          _c(
                            "p",
                            { staticClass: "control" },
                            [
                              _c(
                                "b-dropdown",
                                {
                                  model: {
                                    value:
                                      _vm.form.options[optionName]["selected"],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form.options[optionName],
                                        "selected",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.options[optionName]['selected']"
                                  }
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "button",
                                      attrs: { slot: "trigger" },
                                      slot: "trigger"
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "label." +
                                                  _vm.form.options[optionName][
                                                    "selected"
                                                  ]
                                              )
                                            ) +
                                            " "
                                        )
                                      ]),
                                      _c("b-icon", {
                                        attrs: { icon: "menu-down" }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._l(option.options, function(subOpt) {
                                    return _c(
                                      "b-dropdown-item",
                                      { key: subOpt, attrs: { value: subOpt } },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("label." + subOpt)) +
                                            " "
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _c("b-input", {
                            attrs: {
                              placeholder: _vm.$t("placeholder.input_filter"),
                              expanded: ""
                            },
                            model: {
                              value: _vm.form.options[optionName]["value"],
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form.options[optionName],
                                  "value",
                                  $$v
                                )
                              },
                              expression: "form.options[optionName]['value']"
                            }
                          })
                        ]
                      : option.type === "select-floor"
                      ? [
                          _c(
                            "b-select",
                            {
                              attrs: { expanded: "" },
                              model: {
                                value: _vm.form.options[optionName],
                                callback: function($$v) {
                                  _vm.$set(_vm.form.options, optionName, $$v)
                                },
                                expression: "form.options[optionName]"
                              }
                            },
                            _vm._l(option.options(_vm.floors), function(item) {
                              return _c(
                                "option",
                                {
                                  key: item[option.value],
                                  domProps: { value: item[option.value] }
                                },
                                [_vm._v(" " + _vm._s(item[option.label]) + " ")]
                              )
                            }),
                            0
                          )
                        ]
                      : option.type === "boolean"
                      ? [
                          _c(
                            "b-switch",
                            {
                              attrs: { type: "is-success" },
                              model: {
                                value: _vm.form.options[optionName],
                                callback: function($$v) {
                                  _vm.$set(_vm.form.options, optionName, $$v)
                                },
                                expression: "form.options[optionName]"
                              }
                            },
                            [
                              _vm.form.options[optionName]
                                ? _c("span", [_vm._v(" ON ")])
                                : _c("span", [_vm._v("OFF")])
                            ]
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              }),
              1
            )
          ])
        ],
        1
      ),
      _c("footer", { staticClass: "modal-card-foot" }, [
        _c(
          "button",
          {
            staticClass: "button has-text-weight-semibold",
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_vm._v(" " + _vm._s(_vm.$t("button.cancel")) + " ")]
        ),
        _c(
          "button",
          {
            staticClass: "button is-primary has-text-weight-bold",
            on: {
              click: function($event) {
                return _vm.handleApplyChange()
              }
            }
          },
          [_vm._v(" " + _vm._s(_vm.buttonSaveText) + " ")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }